var map = {
	"./bundle_mapping.svg": "37fc",
	"./create_product_from_report.svg": "a4ac",
	"./data_import.svg": "d06b",
	"./inventory_forecasting.svg": "e8bb",
	"./inventory_problem.svg": "6998",
	"./inventory_replenishment.svg": "7a7d",
	"./inventory_transfer.svg": "621f",
	"./multi-store-data-combination.svg": "f188",
	"./product_segment.svg": "5dcc",
	"./replenishment_setting.svg": "9d1a",
	"./report_page_navigation.svg": "8588",
	"./report_page_visualization.svg": "fb94",
	"./schedule_create.svg": "fccb",
	"./schedule_edit.svg": "886d",
	"./schedule_introduction.svg": "4323",
	"./setting_incoming_inventory.svg": "6767",
	"./setup_low_stock.svg": "f98e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dff";